export function createEvent(type: string) {
    if (typeof (Event) === 'function') {
        return new Event(type);
    }
    else {
        let event = document.createEvent('Event');
        event.initEvent(type, true, true);
        return event;
    }
}